import { render } from "./EditAppInstance.vue?vue&type=template&id=5127b98a&scoped=true"
import script from "./EditAppInstance.vue?vue&type=script&lang=ts"
export * from "./EditAppInstance.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5127b98a"

export default script